import { render, staticRenderFns } from "./my_informal_wage_record_modal.vue?vue&type=template&id=06fb8a4b&scoped=true"
import script from "./my_informal_wage_record_modal.vue?vue&type=script&lang=js"
export * from "./my_informal_wage_record_modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06fb8a4b",
  null
  
)

export default component.exports